import styled from 'styled-components';

export const CompanyPageHeroDIV = styled.div`
  position: relative;
  margin: calc(var(--SiteNav--height) * -1) 0 0;
  padding-top: var(--spacing--XL);
  background: var(--color--cobalt-100);
  overflow: hidden;
`;

export const CompanyPageHeroContentDIV = styled.div`
  padding: var(--spacing--S) 0 var(--spacing--L);
  margin: 0 auto;
  text-align: center;
  max-width: max(837px, calc((var(--container-width) / 12 * 8) - (var(--spacing--M) * 4 / 12)));

  p {
    color: var(--color--text-default);
    margin: 0 auto;
    max-width: var(--text-max-width);
    text-wrap: balance;
  }
`;
